// @flow
import React from "react";

import routesConfig from "../../../configs/routesConfig";
import {
  checkAuthentication,
  navigateToRouteHelper,
  sendGaEvent
} from "../../../services/helpers";
import MenuBar from "./menuBar";

type Props = {
  userProfile: Object,
  setColumnWiseRoutes: Function,
  menuBarState: Object,
  toggleMenuBarDisplay: Function
};

class MenuBarWrapper extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.columnWiseRoutes = [];
    this.navigateToRouteFn = this.navigateToRoute.bind(this);
  }
  componentDidMount() {
    const routesConfigClone = JSON.parse(JSON.stringify(routesConfig));
    this.authorizedRoutes = this.getAuthorizedRoutes(
      routesConfigClone,
      this.props.userProfile
    );
    this.setColWiseAuthRoutes(this.authorizedRoutes);
  }
  setColWiseAuthRoutes(authorizedRoutes: Array<any>) {
    const columnWiseRoutes = [];
    const column1Routes = authorizedRoutes.filter(
      route => route.menuBarColumnNo === 1
    );
    const column2Routes = authorizedRoutes.filter(
      route => route.menuBarColumnNo === 2
    );
    const column3Routes = authorizedRoutes.filter(
      route => route.menuBarColumnNo === 3
    );
    const column4Routes = authorizedRoutes.filter(
      route => route.menuBarColumnNo === 4
    );
    const column5Routes = authorizedRoutes.filter(
      route => route.menuBarColumnNo === 5
    );
    const column6Routes = authorizedRoutes.filter(
      route => route.menuBarColumnNo === 6
    );
    columnWiseRoutes.push(column1Routes);
    columnWiseRoutes.push(column2Routes);
    columnWiseRoutes.push(column3Routes);
    columnWiseRoutes.push(column4Routes);
    columnWiseRoutes.push(column5Routes);
    columnWiseRoutes.push(column6Routes);
    this.props.setColumnWiseRoutes(columnWiseRoutes);
  }
  getAuthorizedRoutes(routesConfigClone: Object, userProfile: Object) {
    let routesConfigArr = routesConfigClone;
    routesConfigArr = routesConfigArr
      .map(routeObj => {
        if (routeObj.subRoutes) {
          const newRoutWithSubRouteObj = routeObj;
          newRoutWithSubRouteObj.subRoutes = routeObj.subRoutes
            .map(subRouteObj => checkAuthentication(subRouteObj, userProfile))
            .filter(subRoute => subRoute !== null);
          return newRoutWithSubRouteObj;
        }
        return checkAuthentication(routeObj, userProfile);
      })
      .filter(route => route !== null);
    return routesConfigArr;
  }

  sendGaEventObject(label) {
    const eventObj = {
      event_category: "ZoomOpsMenuBarItem",
      event_action: "Menu-click",
      event_label: label
    };
    sendGaEvent(eventObj, "zoom-panel-perf-menu-click", this.props.userProfile);
  }

  navigateToRoute(routeObj: Object) {
    navigateToRouteHelper(routeObj);
    if (routeObj.route) {
      this.sendGaEventObject(routeObj.title.toLowerCase());
      if (routeObj.zoomuinewroute) {
        this.props.toggleMenuBarDisplay(false);
      }
    }
  }

  authorizedRoutes: Array<any>;
  columnWiseRoutes: Array<any>;
  navigateToRouteFn: Function;

  renderRouteColumns() {
    return this.columnWiseRoutes.map(() => (
      <div className="routes-column-wrapper">abc</div>
    ));
  }
  render() {
    return (
      <MenuBar
        menuBarState={this.props.menuBarState}
        toggleMenuBarDisplay={this.props.toggleMenuBarDisplay}
        navigateToRoute={this.navigateToRouteFn}
      />
    );
  }
}

export default MenuBarWrapper;



// WEBPACK FOOTER //
// ./app/components/commons/menuBar/menuBarWrapper.js